import * as React from "react";

// @ts-ignore
import logo from "../../../assets/images/logo.svg";

interface IProps {
  className?: string;
  onClick?: () => void;
}

export const SalaryoLogo: React.SFC<IProps> = (props: IProps) => {
  return <img src={logo} className={props.className} onClick={props.onClick} />;
};



// WEBPACK FOOTER //
// ./src/components/Icons/SalaryoLogo/SalaryoLogo.tsx